












































































































































import { CartItem } from '@/models/cart/cart-item'
import {
  OperationMode,
  operationModes,
} from '@spa/components/organisms/cart/model/item/operation-mode'
import { none, Option } from 'fp-ts/lib/Option'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import MaybeLink from '@/components/atoms/MaybeLink.vue'
import BundleDiscountLabel from '@/components/molecules/discount/BundleDiscountLabel.vue'
import { PurchaseCountLimitRange } from '@/models/cart/purchase-count/limit/purchase-count-limit-specification'
import { BundleDiscount } from '@/services/api/bundle-discount'
import { UsualPower } from '@/services/api/usual-power/usual-power'
import { BrandRouteResolver } from '@/util/brandRouteResolver'
import { InstanceResolver } from '@/util/instanceResolver'
import UsualPowerComparisonMessage from '@spa/components/organisms/cart/UsualPowerComparisonMessage.vue'
import { PluginMixin } from '@spa/mixins/plugin'
import { isShouldPromoteCountSelection } from '@spa/store/modules/cart/types/reason-for-cannot-be-purchased'

@Component({
  components: {
    MaybeLink,
    BundleDiscountLabel,
    UsualPowerComparisonMessage,
  },
})
/**
 * FIXME: コンポーネント内部に editable / readonly の情報が混在することによる肥大化を解消する
 *
 * editable / readonly の情報が直接コンポーネント内部に混在していることで、
 * editable/onlyXxx の場合のみ考慮すれば良い状態を read only でも考慮する必要が生じている.
 * （あるいは、編集機能を拡張したいのに read-only に影響しないか都度都度考慮する必要がある）
 * 結果、コンポーネントの肥大化に繋がっている. SOLIDのSRP違反とも言える.
 * ex. purchasableRange は editable の場合のみ考慮すれば良いが、read only な場でもこのコンポーネントは利用されている.
 *
 * ## 案1 read only と editable/onlyChangeCount でコンポーネントを分離?
 * 状態を作るのではなく、 操作範囲でそれぞれコンポーネントを分ける.
 * 単にコンポーネントを二種類用意するとデザインやレイアウトを都度再実装する必要が生じるため、
 * デザインや各種UIパーツの配置を担当するコンポーネントを専用に作り、それは共通化する.
 *
 * 共通コンポーネントに、slotなど経由で後から編集用UI or 参照用UIを挿入可能にして、
 * それぞれのコンテクストに応じた最低限の知識と実装を注入可能な形にする.
 *
 * ## 案2 operation mode で、操作方法による差異を吸収？
 * それぞれの操作方法でパラメータが食い違う点は、それぞれの operation mode を生成するタイミングで解決する.
 * コンポーネントは基本 editable 前提で実装する.
 * - operation mode 呼び出しとイベントハンドリングのマッピング
 * - operation mode に応じた表示のON/OFF
 * がコンポーネントが operation mode を意識するべき箇所となる.
 * @see https://github.com/my-color/front/pull/5375#discussion_r657626096
 */
export default class Item extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ default: () => operationModes.editable })
  operationMode: OperationMode

  @Prop({ required: true })
  cartItem: CartItem

  @Prop({ required: true })
  price: string

  @Prop({ required: true })
  sizeLabel: string | null

  @Prop({ required: true })
  colorLabel: string | null

  /**
   * カート画面と注文画面で遷移を許可するかどうかを切り替える必要がある
   * 注文手続き以降は離脱防止のため遷移できないようにしたい
   * @see https://github.com/my-color/front/issues/7231
   */
  @Prop({ default: false })
  allowTransitionToItemDetail: boolean

  @Prop({ default: false })
  isValid: boolean

  get unitCount(): number {
    return this.cartItem.unitCount
  }

  /**
   * requiredではないため、ラベル表示機能のための一種のフラグとして機能している。
   * ex. カート画面からはラベル表示あり、注文確認画面からはラベル表示一律なし。
   * フラグとして出し分けるものが増えてくるなら、ユースケース自体が異なっている徴候といえるので、
   * 共通部品は使うにしても全体として別のコンポーネントに切り分けたほうがよい。
   */
  @Prop({ default: () => none })
  bundleDiscount: Option<BundleDiscount>

  /**
   * カート画面など、編集時には必須.
   * 一方で注文確認画面など、参照時には不要.
   *
   * read / write 両方の役割を一つのコンポーネントに押し込んでいるため、
   * 一方では不要だが一方では必要な情報となっており、I/Fとしてはoptional扱いにせざるをえない.
   *
   * TODO: read-only と editable でコンポーネントを別にすることで、editableでのみ必要な知識として調節.
   */
  @Prop({ default: () => ({ max: 0, min: 0 }) })
  purchasableRange: PurchaseCountLimitRange

  @Prop({ default: () => () => { /* ignore */ } })
  updateItem: (item: CartItem, newCount: number) => void

  @Prop({ default: () => () => { /* ignore */ } })
  removeItem: (item: CartItem) => void

  @Prop({ required: true })
  usualPowerInfo: UsualPower | null

  // FIXME: イベントハンドラは操作対象のオブジェクトを直接受け取る形に統一
  //
  // 下記の onXxx は、既存の実装がDOMイベントを直接やり取りするI/Fになっているのを一旦ここで吸収し、
  // 利用側コンポーネントまで変更の影響を波及させないための一時措置.
  onChangeCount(event): void {
    this.updateItem(this.cartItem, parseInt(event.target.value, 10))
  }

  get maybeItemDetailLink(): string | null {
    return this.allowTransitionToItemDetail ?
      this.itemDetailLink :
      null
  }

  get itemDetailLink(): string {
    return BrandRouteResolver.makeResourceEndpoint({
      brand: this.cartItem.brandEnglishName!,
      path: [
        'item',
        this.cartItem.rootShortId!,
      ],
      query: {
        color: this.cartItem.colorName,
      },
    })
  }

  get unitCountList(): number[] {
    return _.range(
      this.purchasableRange.min,
      this.purchasableRange.max + 1
    )
  }

  get shouldShowBrand(): boolean {
    return InstanceResolver.isMulti()
  }

  get bundleLabelColor(): string {
    return this.bundleDiscount.fold(
      // TODO より上流でデフォルト値の設定を行う。
      '',
      d => d.label_color
    )
  }

  get shouldShowBundleDiscountLabel(): boolean {
    return this.bundleDiscount.isSome()
  }

  get itemName(): string {
    return this.cartItem.name || 'NO NAME'
  }

  get sizeAndColorHtml(): string {
    return [
      ...this.sizeLabel ? [`<span class="p-cart-item-detail__size-color__size">${this.sizeLabel}</span>`] : [],
      ...this.colorLabel ? [`<span class="p-cart-item-detail__size-color__color">${this.colorLabel}</span>`] : [],
    ].join('/')
  }

  get priceDifferenceNotCheckedMessage(): string | null {
    const priceDifferenceNotChecked = this.cartItem.reasonForCannotBePurchased.list.find(
      reason => reason.type === 'priceDifferenceNotChecked'
    )
    if (!priceDifferenceNotChecked) {
      return null
    }

    return priceDifferenceNotChecked.message
  }

  get shouldPromoteCountSelectionViewModel(): ShouldPromoteCountSelectionViewModel {
    const shouldPromoteCountSelection = this.cartItem.reasonForCannotBePurchased.list.find(
      reason => isShouldPromoteCountSelection(reason)
    ) || null

    if (
      !shouldPromoteCountSelection ||
      !isShouldPromoteCountSelection(shouldPromoteCountSelection)
    ) {
      return emptyShouldShowPromoteCountSelectionViewModel
    }

    return {
      show: true,
      message: shouldPromoteCountSelection.message,
      optionList: _.range(
        shouldPromoteCountSelection.count.min,
        shouldPromoteCountSelection.count.max + 1
      ),
    }
  }

  /**
   * コンタクトレンズアイテムかどうかを判定
   */
  get isContactLensItem(): boolean {
    return !!(this.cartItem.root && this.cartItem.root.isContactLens)
  }

  /**
   * コンタクトレンズアイテムの度数の pathname を取得
   */
  get itemPowerPathname(): string | null {
    if (!this.isContactLensItem) {
      return null
    }

    return this.cartItem.sizeTagPathname || null
  }

}

interface ShouldPromoteCountSelectionViewModel {
  show: boolean
  message: string
  optionList: number[]
}

const emptyShouldShowPromoteCountSelectionViewModel: ShouldPromoteCountSelectionViewModel = {
  show: false,
  message: '',
  optionList: [],
}
